import { TOptions } from 'i18next'
import { FormatXMLElementFn, PrimitiveType } from 'intl-messageformat'
import { Trans } from 'next-i18next/pages'
import * as React from 'react'
import { TLocoType } from 'shared/hooks/use-loco-translation'

interface TransLocoBaseProps {
  i18nKey: string
  components?:
    | readonly React.ReactElement<any>[]
    | { readonly [tagName: string]: React.ReactElement<any> }
  values?: any
}

interface TransLocoWithT extends TransLocoBaseProps {
  t: TLocoType
  tICU?: never
}

interface TransLocoWithTICU extends TransLocoBaseProps {
  t?: never
  tICU: (
    assetKey: string,
    values: Record<string, PrimitiveType | FormatXMLElementFn<string>>,
    options?: TOptions,
  ) => any
}

export type TransLocoProps = TransLocoWithT | TransLocoWithTICU

const TransLoco = ({ t, tICU, i18nKey, components, values }: TransLocoProps) => {
  const translationFunction = tICU || t
  const transT = (() => translationFunction(i18nKey, values)) as React.ComponentProps<
    typeof Trans
  >['t']

  return <Trans t={transT} i18nKey={i18nKey} components={components} values={values} />
}

export default TransLoco
